import React, { useState, useRef, useEffect } from 'react';
import { storeSet } from '../store';
import './LanguageSelector.css';

const LANGUAGES = [
  { code: 'en',    flag: '🇺🇸', label: 'English',                native: 'English',            rtl: false },
  { code: 'hi',    flag: '🇮🇳', label: 'Hindi',                  native: 'हिंदी',               rtl: false },
  { code: 'mr',    flag: '🇮🇳', label: 'Marathi',                native: 'मराठी',               rtl: false },
  { code: 'gu',    flag: '🇮🇳', label: 'Gujarati',               native: 'ગુજરાતી',             rtl: false },
  { code: 'ta',    flag: '🇮🇳', label: 'Tamil',                  native: 'தமிழ்',               rtl: false },
  { code: 'te',    flag: '🇮🇳', label: 'Telugu',                 native: 'తెలుగు',              rtl: false },
  { code: 'kn',    flag: '🇮🇳', label: 'Kannada',                native: 'ಕನ್ನಡ',               rtl: false },
  { code: 'ml',    flag: '🇮🇳', label: 'Malayalam',              native: 'മലയാളം',              rtl: false },
  { code: 'pa',    flag: '🇮🇳', label: 'Punjabi',                native: 'ਪੰਜਾਬੀ',              rtl: false },
  { code: 'bn',    flag: '🇧🇩', label: 'Bengali',                native: 'বাংলা',               rtl: false },
  { code: 'ur',    flag: '🇵🇰', label: 'Urdu',                   native: 'اردو',                rtl: true  },
  { code: 'es',    flag: '🇪🇸', label: 'Spanish',                native: 'Español',             rtl: false },
  { code: 'fr',    flag: '🇫🇷', label: 'French',                 native: 'Français',            rtl: false },
  { code: 'de',    flag: '🇩🇪', label: 'German',                 native: 'Deutsch',             rtl: false },
  { code: 'it',    flag: '🇮🇹', label: 'Italian',                native: 'Italiano',            rtl: false },
  { code: 'pt',    flag: '🇧🇷', label: 'Portuguese',             native: 'Português',           rtl: false },
  { code: 'nl',    flag: '🇳🇱', label: 'Dutch',                  native: 'Nederlands',          rtl: false },
  { code: 'ru',    flag: '🇷🇺', label: 'Russian',                native: 'Русский',             rtl: false },
  { code: 'pl',    flag: '🇵🇱', label: 'Polish',                 native: 'Polski',              rtl: false },
  { code: 'uk',    flag: '🇺🇦', label: 'Ukrainian',              native: 'Українська',          rtl: false },
  { code: 'zh-CN', flag: '🇨🇳', label: 'Chinese (Simplified)',   native: '中文(简体)',            rtl: false },
  { code: 'zh-TW', flag: '🇹🇼', label: 'Chinese (Traditional)', native: '中文(繁體)',            rtl: false },
  { code: 'ja',    flag: '🇯🇵', label: 'Japanese',               native: '日本語',               rtl: false },
  { code: 'ko',    flag: '🇰🇷', label: 'Korean',                 native: '한국어',               rtl: false },
  { code: 'ar',    flag: '🇸🇦', label: 'Arabic',                 native: 'العربية',             rtl: true  },
  { code: 'fa',    flag: '🇮🇷', label: 'Persian',                native: 'فارسی',               rtl: true  },
  { code: 'he',    flag: '🇮🇱', label: 'Hebrew',                 native: 'עברית',               rtl: true  },
  { code: 'tr',    flag: '🇹🇷', label: 'Turkish',                native: 'Türkçe',              rtl: false },
  { code: 'vi',    flag: '🇻🇳', label: 'Vietnamese',             native: 'Tiếng Việt',          rtl: false },
  { code: 'th',    flag: '🇹🇭', label: 'Thai',                   native: 'ภาษาไทย',             rtl: false },
  { code: 'id',    flag: '🇮🇩', label: 'Indonesian',             native: 'Bahasa Indonesia',    rtl: false },
  { code: 'ms',    flag: '🇲🇾', label: 'Malay',                  native: 'Bahasa Melayu',       rtl: false },
  { code: 'sv',    flag: '🇸🇪', label: 'Swedish',                native: 'Svenska',             rtl: false },
  { code: 'da',    flag: '🇩🇰', label: 'Danish',                 native: 'Dansk',               rtl: false },
  { code: 'no',    flag: '🇳🇴', label: 'Norwegian',              native: 'Norsk',               rtl: false },
  { code: 'fi',    flag: '🇫🇮', label: 'Finnish',                native: 'Suomi',               rtl: false },
  { code: 'el',    flag: '🇬🇷', label: 'Greek',                  native: 'Ελληνικά',            rtl: false },
  { code: 'ro',    flag: '🇷🇴', label: 'Romanian',               native: 'Română',              rtl: false },
  { code: 'hu',    flag: '🇭🇺', label: 'Hungarian',              native: 'Magyar',              rtl: false },
  { code: 'cs',    flag: '🇨🇿', label: 'Czech',                  native: 'Čeština',             rtl: false },
];

function getCurrentLang() {
  const match = document.cookie.match(/googtrans=\/en\/([^;]+)/);
  return match ? match[1] : 'en';
}

function clearGoogCookies() {
  const expired = 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = 'googtrans=; ' + expired;
  document.cookie = 'googtrans=; ' + expired + ' domain=' + window.location.hostname + ';';
  // Also clear dot-prefixed domain variant
  document.cookie = 'googtrans=; ' + expired + ' domain=.' + window.location.hostname + ';';
}

function changeLanguage(code) {
  if (code === 'en') {
    clearGoogCookies();
    // Use Google's own restore function if available
    const restore = window.google &&
      window.google.translate &&
      window.google.translate.TranslateElement &&
      window.google.translate.TranslateElement.getInstance &&
      window.google.translate.TranslateElement.getInstance();
    if (restore && restore.restore) {
      restore.restore();
      return;
    }
    // Trigger via the hidden combo select
    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = '';
      select.dispatchEvent(new Event('change'));
      // Give it a moment then reload to ensure full reset
      setTimeout(() => window.location.reload(), 300);
      return;
    }
    window.location.reload();
  } else {
    const val = '/en/' + code;
    document.cookie = 'googtrans=' + val + '; path=/;';
    document.cookie = 'googtrans=' + val + '; path=/; domain=' + window.location.hostname + ';';
    document.cookie = 'googtrans=' + val + '; path=/; domain=.' + window.location.hostname + ';';

    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = code;
      select.dispatchEvent(new Event('change'));
      return;
    }
    window.location.reload();
  }
}

const LanguageSelector = () => {
  const currentCode = getCurrentLang();
  const initial = LANGUAGES.find(l => l.code === currentCode) || LANGUAGES[0];

  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(initial);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const filtered = LANGUAGES.filter(
    l =>
      l.label.toLowerCase().includes(search.toLowerCase()) ||
      l.native.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (lang) => {
    setSelected(lang);
    setOpen(false);
    setSearch('');
    storeSet('language', { code: lang.code });   // persist to Railway so all devices sync
    changeLanguage(lang.code);
  };

  return (
    <div className="ls-wrap" ref={ref} translate="no">
      <button className="ls-btn notranslate" onClick={() => setOpen(o => !o)} aria-label="Select language">
        <svg className="ls-globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
        <span className="ls-flag">{selected.flag}</span>
        <span className="ls-label">{selected.label}</span>
        <svg className={`ls-chevron${open ? ' open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="12" height="12">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {open && (
        <div className="ls-dropdown notranslate" translate="no">
          <div className="ls-search-wrap">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              className="ls-search"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search language…"
              autoFocus
            />
          </div>
          <div className="ls-list">
            {filtered.length === 0 && (
              <div className="ls-empty">No language found</div>
            )}
            {filtered.map(lang => (
              <button
                key={lang.code}
                className={`ls-item${selected.code === lang.code ? ' ls-active' : ''}`}
                onClick={() => handleSelect(lang)}
                dir={lang.rtl ? 'rtl' : 'ltr'}
              >
                <span className="ls-item-flag">{lang.flag}</span>
                <span className="ls-item-label">{lang.label}</span>
                <span className="ls-item-native" dir={lang.rtl ? 'rtl' : 'ltr'}>{lang.native}</span>
                {selected.code === lang.code && (
                  <svg className="ls-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="14" height="14">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
